import { Bedarf } from '../../../types/bedarf';
import { ModalState } from './useBedarfActions';
import { ChangePriorityModal } from './ChangePriorityModal';
import { SelectBewerberKennenlernenModal } from './SelectBewerberKennenlernenModal';

interface BedarfActionModalsProps {
  bedarf: Bedarf;
  modals: {
    kennenlernen: ModalState;
    priority: ModalState;
  };
  onModalComplete?: () => void;
}

export function BedarfActionModals({
  bedarf,
  modals,
  onModalComplete,
}: BedarfActionModalsProps) {
  const childName = bedarf.childLastName
    ? `${bedarf.childFirstName} ${bedarf.childLastName}`
    : bedarf.childFirstName;

  return (
    <>
      {/* Kennenlernen Modal */}
      <SelectBewerberKennenlernenModal
        isOpen={modals.kennenlernen.isOpen}
        onClose={modals.kennenlernen.close}
        bedarfId={bedarf.id}
        childName={childName}
        parentEmail={bedarf.parentEmail}
        onSuccess={onModalComplete}
      />

      {/* Priority Modal */}
      <ChangePriorityModal
        isOpen={modals.priority.isOpen}
        onClose={modals.priority.close}
        bedarfId={bedarf.id}
        currentPriority={bedarf.priority}
        childName={childName}
        onSuccess={onModalComplete}
      />
    </>
  );
}
